/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Nav_Stock_Out_NotesInputs */

const vi_scl_nav_stock_out_notes = /** @type {(inputs: Scl_Nav_Stock_Out_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu xuất`)
};

/**

* @param {Scl_Nav_Stock_Out_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_nav_stock_out_notes = /** @type {((inputs?: Scl_Nav_Stock_Out_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Nav_Stock_Out_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_nav_stock_out_notes(inputs)
});